import React from "react";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import { Button, Menu, MenuItem, Box } from "@mui/material";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import { makeStyles } from "@mui/styles";
import { ALL, FULL_TIME, PART_TIME } from "../util/constants";
import SeniorityListPdfExport from "../components/SeniorityListPdfExport";
import { getStationTimeZoneDateTimeStringFromUTCInteger } from "../util/timeZoneService";

const useStyles = makeStyles((theme) => ({
  root: {
    margin: "auto",
    position: "fixed",
    width: "100%",
  },
  exportButton: {},
  seniorityInput: {
    margin: "5px",
  },
  seniorityFullPartTimeExport: {
    display: "flex",
    justifyContent: "space-between",
    marginLeft: "4.25vw",
    marginRight: "3.8vw",
    paddingTop: "0.3vw",
    paddingBottom: "0.4vw",
  },
  toggleButtonGroup: {
    "& .MuiButtonBase-root": {
      color: theme.palette.primary.main,
      borderColor: theme.palette.primary.main,
      padding: " 6px 14px",
    },
    "& .Mui-selected": {
      color: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.primary.main,
    },
    "& .MuiButtonBase-root:hover": {
      color: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.primary.main,
      opacity: 0.6,
    },
  },
  commentsStyle: {
    textDecoration: "underline",
    fontSize: "14px",
    textTransform: "none",
  },
  lastPublished: {
    textAlign: "left",
    marginLeft: "3.1vw",
    paddingLeft: "20px",
    fontSize: "14px",
  },
  lastPublishedSeniorityTable: {
    paddingRight: "3.8vw",
    paddingLeft: "4.25vw",
  },
}));
const LastPublishedSeniorityListPage = (props) => {
  const classes = useStyles();

  return (
    <>
      <div
        hidden={
          props.selectedTab !== 1 || props.isLoading || props.publishedTimestamp === "" || !props.seniorityList.length
        }
        className={classes.lastPublished}
      >
        Last published by {props.publishedBy}
        {!props.isLoading && props.publishedTimestamp !== ""
          ? " on " +
            getStationTimeZoneDateTimeStringFromUTCInteger(props.publishedTimestamp, props.station).toFormat(
              "MM/dd/yyyy T ZZZZ"
            )
          : ""}
        <Button onClick={props.handleComment} className={classes.commentsStyle}>
          (View comment)
        </Button>
      </div>
      <div className={`${classes.seniorityInput} ${classes.seniorityFullPartTimeExport}`}>
        <ToggleButtonGroup
          size="small"
          exclusive
          value={props.filterSetting}
          onChange={props.handleFilterSettingChange}
          color={"primary"}
          className={classes.toggleButtonGroup}
        >
          <ToggleButton value={FULL_TIME}>FT {props.ftCount !== "" ? "(" + props.ftCount + ")" : ""}</ToggleButton>
          <ToggleButton value={PART_TIME}>PT {props.ptCount !== "" ? "(" + props.ptCount + ")" : ""}</ToggleButton>
          <ToggleButton value={ALL}>
            ALL
            {props.ftCount !== ""
              ? "(" + (props.ftCount === "-" ? props.ftCount : props.ftCount + props.ptCount) + ")"
              : ""}
          </ToggleButton>
        </ToggleButtonGroup>

        <Button
          data-testid="seniorityListPage-export-button"
          className={classes.exportButton}
          variant="contained"
          color="primary"
          size="medium"
          onClick={props.handleExportBtnClick}
          startIcon={<UploadFileIcon />}
          disabled={props.isLoading || !props.seniorityList.length}
        >
          Export All
        </Button>
        <Menu
          data-testid="seniorityListPage-export-menu"
          className={classes.exportMenu}
          anchorEl={props.exportsMenuAnchor}
          open={!!props.exportsMenuAnchor}
          onClose={props.handleExportMenuClose}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
        >
          <MenuItem onClick={props.handleCsvMenuItemClick}>Admin CSV</MenuItem>
          <SeniorityListPdfExport
            seniorityList={props.seniorityList}
            contract={props.userContract}
            seniorityListType={props.seniorityListType}
            station={props.station}
            generatedTimestamp={props.publishedTimestamp}
            workgroup={props.workgroup}
            criticalMissingDataCount={props.criticalMissingDataCount}
            onExportMenuClose={props.handleExportMenuClose}
          />
        </Menu>
      </div>
      <div>
        <Box sx={{ height: `calc(85vh - 285px)` }} className={classes.lastPublishedSeniorityTable}>
          {props.renderSeniorityList(props.displayedSeniorityList)}
        </Box>
      </div>
    </>
  );
};
export default LastPublishedSeniorityListPage;
